export default __webpack_public_path__ + "static/node_runner_tablet@2x-acf2150887e58fec0eb8dc26c98b132b.png";